import { Routes, Route } from 'react-router-dom';
import DefaultLayout from './Layout/DefaultLayout/DefaultLayout';
import About from './components/About/About';
import Knowledge from './components/Knowledge/Knowledge';
import Projects from './components/Projects/Projects';
import Blog from './components/Blog/Blog';
import NotFound from './components/NotFound/NotFound';

export default function HomeApp() {
    return (
        <Routes>
            <Route path="/" element={<DefaultLayout />}>
                <Route path="about" element={<About />} />
                <Route path="education" element={<Knowledge />} />
                <Route path="portfolio" element={<Projects />} />
                <Route path="blog" element={<Blog />} />
            </Route>
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
}
